import type { SubtitleDocument } from '../../core';

/**
 * A brand-new, empty document for the "start from scratch" entry point
 * (cue-forge-wwy.2) — EmptyState's counterpart to transcription's
 * `freshTranscriptDocument` (`transcribe/completion.ts`), used when there is no
 * source content at all rather than a transcript to seed cues from. `srt` is the
 * same neutral default used there and by `resync.worker.ts`'s synthetic doc (see
 * `normalizeSourceFormat`'s doc comment, `session.ts`). Loaded via the session's
 * `loadFreshDocument`, whose EMPTY-only contract is the caller's job to respect.
 */
export function blankDocument(): SubtitleDocument {
  return { cues: [], metadata: { sourceFormat: 'srt' }, warnings: [] };
}
